import { ExecutionEnvironment } from './utils/ExecutionEnvironment'

export async function getPolyfills() {
  if (!ExecutionEnvironment.isSsr && window.navigator.appVersion.includes('Safari')) {
    const smoothScroll = await import(/* webpackChunkName: "polyfill~smoothscroll-polyfill" */ 'smoothscroll-polyfill')
    smoothScroll.polyfill()
  }
}
